// extracted by mini-css-extract-plugin
export default {"container":"ImagePopup_container__N57k1"};